import { render, staticRenderFns } from "./ExpandingBusiness.vue?vue&type=template&id=5e7e5e4c&scoped=true&"
import script from "./ExpandingBusiness.vue?vue&type=script&lang=js&"
export * from "./ExpandingBusiness.vue?vue&type=script&lang=js&"
import style0 from "./ExpandingBusiness.vue?vue&type=style&index=0&id=5e7e5e4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7e5e4c",
  null
  
)

export default component.exports